import {useLocation} from "react-router-dom";
import DiscoverLanding from "./discover-landing";
import LifeJourney from "./life-journey";
import type {DiscoverProps} from "./types";
import {usePageTitle} from "../../helpers/usePageTitle";
import './discover.scss';

export default function Discover(props: DiscoverProps) {
    const location = useLocation();
    const isLifeJourney = location.pathname === '/discover/life-journey';

    usePageTitle(isLifeJourney ? 'Life Journey' : 'Discover', isLifeJourney ? 'Discover' : undefined);

    if (isLifeJourney) {
        return <LifeJourney {...props} />;
    }

    return <DiscoverLanding {...props} />;
}
